export const stringsKey = "LanguagePicker";
export const englishStrings = {
	englishOption: "English",
	frenchOption: "French",
	spanishOption: "Spanish",
	languageDetailErrorMessage1: "Error loading ",
	languageDetailErrorMessage2: " language detail, Please try again",
};
